<template lang="pug">
  div
    //- 名刺交換時情報表示
    .row
      .form-group.col-md-6
        label 名刺交換日
        p.form-control-static(data-testid="-exchange-date") {{value.formatted_exdate || app_lang.NO_INPUT}}
      .col-md-6
        .form-group
          label 名刺交換者
          p.form-control-static(data-testid="-exchanger-full-name") {{value.exchanger_full_name}}
          //- 名刺交換者は自身のみなので、選択は行わない
    .form-group
      label 交換場所
      .row
        .col-md-6
          p.form-control-static(v-if="(value.ex_location || !value.ex_location_detail)", data-testid="-exlocation") {{value.ex_location || app_lang.NO_INPUT}}
          p.form-control-static(v-if="value.ex_location_detail", data-testid="-exlocation-detail") {{value.ex_location_detail}}
    .form-group
      label きっかけ
      .row
        .col-md-6
          p.form-control-static(v-if="(value.ex_trigger || !value.ex_trigger_detail)", data-testid="-extrigger") {{value.ex_trigger || app_lang.NO_INPUT}}
          p.form-control-static(v-if="value.ex_trigger_detail", data-testid="-extrigger-detail") {{value.ex_trigger_detail}}
    .form-group
      .row
        .form-group.col-md-6
          label 社内紹介者
          p.form-control-static(data-testid="-referral-user-name")
            span(:title="value.inner_introducer ? value.inner_introducer.full_name : ''") {{value.inner_introducer ? value.inner_introducer.full_name : app_lang.NO_SELECT}}
        .form-group.col-md-6
          label 社外紹介者
          p.form-control-static(data-testid="-referrer-name")
            span(:title="value.outer_introducer ? value.outer_introducer.full_name : ''") {{value.outer_introducer ? value.outer_introducer.full_name : app_lang.NO_SELECT}}

    .form-group
      label 補足
      p.form-control-static(data-testid="-comment") {{value.comment || app_lang.NO_INPUT}}
    .row
      .form-group.col-md-6
        label 年代
        p.form-control-static(data-testid="-age") {{displayAge(value.age)}}
    .form-group
      label その他（特徴など）
      p.form-control-static(data-testid="-feature") {{value.feature || app_lang.NO_INPUT}}

</template>

<script>
import AppModal from '@/components/templates/AppModal'
import AppMessages from '@/components/molecules/AppMessages'
import Loading from '@/components/molecules/Loading'
import DatePicker from '@/components/molecules/DatePicker'
import SelUsers from '@/components/organisms/SelUsers'
import SelPersons from '@/components/organisms/SelPersons'

export default {
  name: 'ExchangeView',
  components: { AppModal, AppMessages, Loading, DatePicker, SelUsers, SelPersons },
  props: {
    /**
     * exchange data
     */
    value: { type: [Object], required: true }
  },
  methods: {
    // 年齢の表示用
    displayAge (age) {
      let message = ''
      if (age === 70) {
        // 70の時は「70以上」と表記
        message = age + ' 代 以上'
      }
      else if (age) {
        message = age + ' 代'
      }
      else {
        // 設定なし：未指定
        message = this.app_lang.NO_SELECT
      }
      return message
    }
  }
}
</script>

<style lang="scss" scoped>
// 余白調整
.form-control-static {
  padding-top: 0;
  padding-bottom: 5px;
  min-height: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/views/ExchangeView.vue